<script>
	// libraries
	import { max } from 'd3-array'

	// components
	import AirRussia from './subcharts/AirRussia.svelte'
	import AirUkraine from './subcharts/AirUkraine.svelte'
	import Battles from './subcharts/Battles.svelte'

	// other
	import { dataAttacks, updateDateAttacks, lastDateAttacks } from './data'
	import { formatDayShort } from './utils'

	// ///////////////////////////////////////////////////////////
	// process data
	// ///////////////////////////////////////////////////////////

	const yMaxUkraine = max(
		dataAttacks,
		(d) => d.airstrikes_shelling_artillery_ukraine
	)
	const yMaxRussia = max(
		dataAttacks,
		(d) => d.airstrikes_shelling_artillery_russia
	)

	const hUkraine = yMaxUkraine / (yMaxUkraine + yMaxRussia)
	const hRussia = yMaxRussia / (yMaxUkraine + yMaxRussia)

	let hovered
</script>

<div class="attacktypes-chart">
	<div class="heading">
		<div class="main">Der Krieg wird zunehmend auf Distanz geführt</div>
	</div>

	<div class="main">
		<div class="subheading" style="color: #9b9b9b">
			Luft-, Raketen- und Artillerieangriffe von
			<span style="color: #FC5757">russischer</span>
			und
			<span style="color: #88A8BA">ukrainischer</span>
			Seite
		</div>

		<div class="chart-container air">
			<div class="chart-container" style="height: {hRussia * 100}%">
				<AirRussia bind:hovered />
			</div>
			<div
				class="chart-container"
				style="height: {hUkraine * 100}%; margin-top:15px">
				<AirUkraine bind:hovered />
			</div>
		</div>

		<div
			class="subheading"
			style="color: #B28686; position: relative; top: 25px">
			Bodenkämpfe (beider Armeen)
		</div>

		<div class="chart-container" style="margin-top: 40px">
			<Battles />
		</div>
	</div>

	<div class="caption">
		<b>Angriffe nach Kriegspartei und Art</b>, Datenstand: {formatDayShort(
			lastDateAttacks
		)}, letzte Aktualisierung: {formatDayShort(updateDateAttacks)}

		Luft-, Raketen- und Artillerieangriffe umfassen Ereignisse, in denen ein
		Ziel aus der Ferne angegriffen wurde. Bodenkämpfe umfassen direkte
		Zusammenstöße beider Armeen. Bereits vor dem russischen Einmarsch kam es in
		den Separatistengebieten zu Angriffen.

		<div class="attribution">
			Daten: <a href="https://acleddata.com/" target="_blank"
				>Armed Conflict Location &amp; Event Data Project</a>
		</div>
	</div>
</div>

<style lang="scss">
	@import 'main.scss';

	.attacktypes-chart {
		font-family: $ff-sans;
		font-size: 17px;
		line-height: 23px;
		font-weight: normal;
		color: #000;

		@media (max-width: 480px) {
			font-size: 16px;
			line-height: 22px;
		}
	}

	.chart-container {
		height: 170px;
		position: relative;
		margin: 0;
	}

	.chart-container.air {
		height: 400px;

		@media (max-width: 480px) {
			height: 300px;
		}

		.chart-container {
			margin: 2px 0;
		}
	}

	.heading .main {
		font-family: $ff-serif;
		font-size: 22px;
		line-height: 30px;
		font-weight: bold;
		margin-bottom: 5px;

		@media (max-width: 480px) {
			font-size: 20px;
			line-height: 24px;
		}
	}

	.subheading {
		font-weight: 600;
		margin: 0 0 20px 0;
	}

	.caption {
		color: #9b9b9b;
		margin-top: 20px;

		b {
			font-weight: 500;
		}
	}

	.attribution {
		display: inline;

		a {
			text-decoration: underline !important;
			color: #9b9b9b !important;
			background: none !important;
			text-shadow: none !important;
		}
	}
</style>
